import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { TableCell, TableRow } from '@mui/material';

import { reverseFormatDate } from '../../../utils/dateFunctions';
import SingleSelect from '../../formElements/SingleSelect';
import Switch from '../../formElements/Switch';

import classes from '../../../commonStyles/tables.module.css';
import local from './participantPrivacy.module.css';

const PrivacyTableRow = ({
    row,
    validDocumentTypes,
    onEditRow,
    onEditDocumentType,
    onEditActive,
    errors,
    isEditDisabled
}) => {
    const documentTypes = useSelector((state) => state.entities.directusService.documentTypes);

    return (
        <>
            <TableRow
                hover
                className={`${classes.basicRowStripes} ${classes.rowHeight}`}
                data-testid={`${row.newRow ? 'admin_privacy_row_new' : `admin_privacy_row_${row.id}`}`}>
                <TableCell>
                    {!row.newRow && row.documentTypeId ? (
                        row.documentType || ''
                    ) : (
                        <SingleSelect
                            id="documentTypeId"
                            placeholder="Select document type..."
                            disabled={false}
                            mandatory={row.documentRequired}
                            customClass="tableRowSelector"
                            customErrorClass="tableRowError"
                            menuItems={validDocumentTypes || []}
                            selectedId={row.documentTypeId || ''}
                            selected={
                                documentTypes.find((el) => el.id === row.documentTypeId) || {}
                            }
                            error={errors[`documentTypeId-${row.id}`]}
                            onChange={(chosenId) =>
                                onEditDocumentType({ ...row, documentTypeId: chosenId })
                            }
                        />
                    )}
                </TableCell>
                <TableCell>
                    {!row.newRow && !row.initialActiveState ? (
                        'No'
                    ) : (
                        <Switch
                            id="active"
                            onOff={true}
                            inline={true}
                            disabled={!row.newRow && isEditDisabled}
                            checked={row.active}
                            customClass="tableRowSwitch"
                            onChange={(e) => onEditActive({ ...row, active: e.target.checked })}
                        />
                    )}
                </TableCell>
                <TableCell>
                    <span className={local.rowDocSwitchAlign}>
                        {!row.newRow ? (
                            row.documentRequired ? (
                                'Yes'
                            ) : (
                                'No'
                            )
                        ) : (
                            <Switch
                                id="documentRequired"
                                onOff={true}
                                inline={true}
                                disabled={false}
                                checked={row.documentRequired}
                                customClass="tableRowSwitch"
                                onChange={(e) =>
                                    onEditRow({ ...row, documentRequired: e.target.checked })
                                }
                            />
                        )}
                    </span>
                </TableCell>
                <TableCell>{reverseFormatDate(row.dateAdded)}</TableCell>
            </TableRow>
        </>
    );
};

PrivacyTableRow.propTypes = {
    row: PropTypes.object,
    validDocumentTypes: PropTypes.arrayOf(PropTypes.object),
    onEditRow: PropTypes.func,
    onEditDocumentType: PropTypes.func,
    onEditActive: PropTypes.func,
    errors: PropTypes.object,
    isEditDisabled: PropTypes.bool
};

export default PrivacyTableRow;
